import styled from 'styled-components';

export const Container = styled.div<{ hasError: boolean }>`
  display: flex;
  flex-direction: column;

  label {
    font-size: 1.2rem;
    margin-bottom: 0.4rem;
    color: #6c6c6c;
  }

  input,
  textarea {
    border: none;
    border: 1px solid #c1c1c1;
    border-radius: 0.8rem;
    height: 4.8rem;
    padding: 0 0.8rem;
    color: #5d4e4f;
    text-transform: uppercase;

    &:disabled {
      cursor: not-allowed;
    }
  }

  textarea {
    resize: none;
    height: 12rem;
    padding-top: 0.8rem;
  }
`;

export const Error = styled.span`
  margin-top: 0.8rem;
  font-size: 1.2rem;
  font-weight: bold;
  color: #ff0033;
`;

export const HelperText = styled.span`
  margin-top: 0.4rem;
  font-size: 1.2rem;
  text-transform: uppercase;
  color: #5d4e4f;
`;
